var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "print-container" }, [
    _c(
      "div",
      { staticClass: "print-toolbar" },
      [
        _c(
          "el-button",
          {
            staticStyle: { float: "right" },
            attrs: { type: "button", size: "mini" },
            on: { click: _vm.downloadHtml },
          },
          [_vm._v(" Download ")]
        ),
      ],
      1
    ),
    _c("iframe", {
      staticClass: "print-div",
      staticStyle: {
        height: "70vh",
        margin: "0 auto",
        display: "block",
        width: "9.7in",
      },
      attrs: { srcdoc: _vm.report },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }